const courses = (isAuthenticated) => [
    {
        path: "courses",
        name: "courses",
        component: () => import("@/modules/courses/index.vue"),
        beforeEnter: isAuthenticated,
        meta: {
            breadcrumbs: [
                {
                    bcDynamic: false,
                    bcLabel: "main",
                    name: "courses",
                },
                {
                    bcDynamic: false,
                    bcLabel: "courses",
                    name: "courses",
                },
            ],
        },
    },
    {
        path: "courses/:item",
        name: "courses-main",
        component: () => import("@/modules/courses/pages/main/index.vue"),
        redirect: "/:lang?/courses/:item/dashboard",
        beforeEnter: isAuthenticated,
        children: [
            {
                path: "dashboard",
                name: "courses-dashboard",
                beforeEnter: isAuthenticated,
                component: () => import("@/modules/courses/pages/dashboard/index.vue"),
                meta: {
                    isChildrenRoute: true,
                    breadcrumbs: [
                        {
                            bcDynamic: false,
                            bcLabel: "main",
                            name: "courses",
                        },
                        {
                            bcDynamic: false,
                            bcLabel: "courses",
                            name: "courses",
                        },
                        {
                            bcDynamic: true,
                            bcModule: "courses",
                            bcGetter: "currentItem",
                            name: "courses-dashboard",
                        },
                    ],
                },
            },
            {
                path: "events/:eventSlug",
                name: "course-event-detail",
                beforeEnter: isAuthenticated,
                component: () =>
                    import("@/modules/courses/pages/events-detail/index.vue"),
                meta: {
                    isChildrenRoute: true,
                    breadcrumbs: [
                        {
                            bcDynamic: false,
                            bcLabel: "main",
                            name: "courses",
                        },
                        {
                            bcDynamic: true,
                            bcModule: "courses",
                            bcGetter: "currentItem",
                            name: "courses-dashboard",
                        },
                        // {
                        //   bcDynamic: false,
                        //   bcLabel: 'events',
                        //   name: 'course-events',
                        // },
                        {
                            bcDynamic: true,
                            bcModule: "coursesEvents",
                            bcGetter: "currentItem",
                            name: "course-event-detail",
                        },
                    ],
                },
            },
            {
                path: "stream",
                name: "course-stream-detail",
                beforeEnter: isAuthenticated,
                component: () =>
                    import("@/modules/courses/pages/streams-detail/index.vue"),
                meta: {
                    isChildrenRoute: true,
                    breadcrumbs: [
                        {
                            bcDynamic: false,
                            bcLabel: "main",
                            name: "courses",
                        },
                        {
                            bcDynamic: true,
                            bcModule: "courses",
                            bcGetter: "currentItem",
                            name: "courses-dashboard",
                        },
                        {
                            bcDynamic: true,
                            bcModule: "coursesStreams",
                            bcGetter: "currentItem",
                            name: "course-stream-detail",
                        },
                    ],
                },
            },
            {
                path: "module/:moduleSlug/lesson",
                name: "courses-lesson-view",
                beforeEnter: isAuthenticated,
                component: () => import("@/modules/courses/pages/lesson-view/index.vue"),
                children: [
                    {
                        path: ":lessonSlug",
                        name: "courses-lesson-detail",
                        component: () =>
                            import("@/modules/courses/pages/lesson-detail/index.vue"),
                        meta: {
                            isChildrenRoute: true,
                            breadcrumbs: [
                                {
                                    bcDynamic: false,
                                    bcLabel: "main",
                                    name: "courses",
                                },
                                {
                                    bcDynamic: true,
                                    bcModule: "courses",
                                    bcGetter: "currentItem",
                                    name: "courses-dashboard",
                                },
                                {
                                    bcDynamic: true,
                                    bcModule: "coursesLesson",
                                    bcGetter: "lesson",
                                    name: "courses-lesson-detail",
                                },
                            ],
                        },
                    },
                ],
                meta: {},
            },
            {
                path: "module/:moduleSlug/home-work/:testId/rules",
                name: "home-work-rules",
                beforeEnter: isAuthenticated,
                component: () => import("@/modules/home-work/pages/rules/index.vue"),
            },
            {
                path: "module/:moduleSlug/home-work/:testId/check",
                name: "home-work-check",
                beforeEnter: isAuthenticated,
                component: () => import("@/modules/home-work/pages/check/index.vue"),
            },
            {
                path: "module/:moduleSlug/home-work/:testId/questions",
                name: "home-work-questions",
                beforeEnter: isAuthenticated,
                component: () => import("@/modules/home-work/pages/questions/index.vue"),
            },
            {
                path: "module/:moduleSlug/home-work/:testId/report",
                name: "home-work-report",
                beforeEnter: isAuthenticated,
                component: () => import("@/modules/home-work/pages/report/index.vue"),
            },
            {
                path: "graduate-work/rules",
                name: "graduate-work-rules",
                beforeEnter: isAuthenticated,
                component: () => import("@/modules/graduate-work/pages/rules/index.vue"),
            },
            {
                path: "graduate-work/:graduateWorkId/check",
                name: "graduate-work-check",
                beforeEnter: isAuthenticated,
                component: () => import("@/modules/graduate-work/pages/check/index.vue"),
            },
            {
                path: "graduate-work/:graduateWorkId/questions",
                name: "graduate-work-questions",
                beforeEnter: isAuthenticated,
                component: () =>
                    import("@/modules/graduate-work/pages/questions/index.vue"),
            },
            {
                path: "graduate-work/:graduateWorkId/report",
                name: "graduate-work-report",
                beforeEnter: isAuthenticated,
                component: () => import("@/modules/graduate-work/pages/report/index.vue"),
            },
            {
                path: ":materialType",
                name: "course-materials",
                beforeEnter: isAuthenticated,
                component: () => import("@/modules/courses/pages/materials/index.vue"),
                meta: {
                    isChildrenRoute: true,
                    breadcrumbs: [
                        {
                            bcDynamic: false,
                            bcLabel: "main",
                            name: "courses",
                        },
                        {
                            bcDynamic: true,
                            bcModule: "courses",
                            bcGetter: "currentItem",
                            name: "courses-dashboard",
                        },
                        {
                            bcDynamic: false,
                            bcDynamicRoute: true,
                            name: "course-materials",
                        },
                    ],
                },
            },
            {
                path: ":materialType/:materialSlug",
                name: "course-material-detail",
                beforeEnter: isAuthenticated,
                component: () =>
                    import("@/modules/courses/pages/materials-detail/index.vue"),
                meta: {
                    isChildrenRoute: true,
                    breadcrumbs: [
                        {
                            bcDynamic: false,
                            bcLabel: "main",
                            name: "courses",
                        },
                        {
                            bcDynamic: true,
                            bcModule: "courses",
                            bcGetter: "currentItem",
                            name: "courses-dashboard",
                        },
                        {
                            bcDynamic: false,
                            bcDynamicRoute: true,
                            name: "course-materials",
                        },
                        {
                            bcDynamic: true,
                            bcModule: "coursesMaterials",
                            bcGetter: "currentItem",
                            name: "course-material-detail",
                        },
                    ],
                },
            },
            {
                path: "bonuses/:slug",
                name: "courses-bonus",
                beforeEnter: isAuthenticated,
                component: () => import("@/modules/courses/pages/materials/index.vue"),
                meta: {
                    isChildrenRoute: true,
                    breadcrumbs: [
                        {
                            bcDynamic: false,
                            bcLabel: "main",
                            name: "courses",
                        },
                        {
                            bcDynamic: false,
                            bcLabel: "courses",
                            name: "courses",
                        },
                        {
                            bcDynamic: true,
                            bcModule: "courses",
                            bcGetter: "currentItem",
                            name: "courses-dashboard",
                            slug: (data) => data.slug,
                            bcLinkText: (data) => data.name,
                        },
                        {
                            bcDynamic: false,
                            bcLabel: "bonuses",
                            name: "courses-bonuses",
                        },
                        {
                            bcDynamic: true,
                            bcModule: "universal",
                            bcGetter: "item",
                            slug: (data) => data.slug,
                            bcLinkText: (data) => data.name,
                        },
                    ],
                },
            },
        ],
    },
];

export default courses;
